import { ApiBase } from '@/api/methods/ApiBase'

export namespace ImportStudentsApi {
  /** csvファイルのパラメータ名(API側はこの名前で取得する) */
  const CSV_PARAM_NAME = 'csv_file'

  /**
   * 生徒一括登録(塾権限)
   *
   * @param mailAddress メールアドレス
   * @param academyCode 塾コード
   * @param csvFile csvファイル
   * @param optionalElement 識別トークン
   */
  export async function academyStudents(
    mailAddress: string,
    academyCode: string,
    csvFile: File,
    optionalElement?: string
  ): Promise<void> {
    const params = {
      mailAddress: mailAddress,
      academyCode: academyCode,
    }

    // 識別トークンの指定がある場合
    if (optionalElement) {
      Object.assign(params, { optionalElement: optionalElement })
    }

    // csvファイル送信用フォームデータ作成
    const formData = new FormData()
    formData.append(CSV_PARAM_NAME, csvFile as Blob)

    await ApiBase.postWithFormData('/manage/users/academy/students', formData, params)
  }
}
